import React, { useEffect } from 'react'
import ReactModal from 'react-modal';
import { AiOutlineClose, AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';

import { formatCurrency } from '../../utils/formatCurrency';

interface IModalProps {
  modalVisible: boolean;
  setModalVisible: (visivel: boolean) => void;
  setQuantidadeConvidadosAdicionaisInput: (quantidade: string) => void;
  onConfirm: () => void;
  titulo: string;
  descricao?: string;
  valorUnitario?: number;
}

const classeBotaoQuantidade = 'flex h-12 w-12 flex-none items-center justify-center rounded-xl border border-zinc-300 text-zinc-700 hover:bg-zinc-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 disabled:text-zinc-300 disabled:hover:bg-transparent';

function Modal({ modalVisible, setModalVisible, setQuantidadeConvidadosAdicionaisInput, onConfirm, titulo, descricao, valorUnitario }: IModalProps) {
  const [quantidadeConvidadosAdicionais, setQuantidadeConvidadosAdicionais] = React.useState('0');

  useEffect(() => {
    setQuantidadeConvidadosAdicionaisInput(quantidadeConvidadosAdicionais);
  }, [quantidadeConvidadosAdicionais]);

  const quantidade = +quantidadeConvidadosAdicionais || 0;

  return (
    <ReactModal
      isOpen={modalVisible}
      appElement={document.getElementById('root') as HTMLElement}
      contentLabel={titulo}
      shouldCloseOnOverlayClick={true}
      onRequestClose={() => setModalVisible(false)}
      overlayClassName='fixed inset-0 z-[99] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in motion-reduce:animate-none'
      className='relative flex w-full max-h-[92dvh] flex-col overflow-hidden rounded-t-2xl bg-white shadow-card outline-none animate-slide-up motion-reduce:animate-none md:max-w-md md:rounded-2xl'
    >
      <div className='flex items-start justify-between gap-3 border-b border-zinc-100 px-5 py-4'>
        <div>
          <h2 className='text-lg font-semibold text-zinc-900'>{titulo}</h2>
          {descricao && <p className='mt-0.5 text-sm text-zinc-500'>{descricao}</p>}
        </div>
        <button
          type='button'
          onClick={() => setModalVisible(false)}
          aria-label='Fechar'
          className='flex h-10 w-10 flex-none items-center justify-center rounded-full text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900'
        >
          <AiOutlineClose className='h-5 w-5' aria-hidden='true' />
        </button>
      </div>

      <div className='space-y-5 px-5 py-5 pb-[max(20px,env(safe-area-inset-bottom))]'>
        <div>
          <label htmlFor='quantidadeConvidadosAdicionais' className='mb-1 block text-sm font-medium text-zinc-700'>Convidados adicionais</label>
          <div className='flex items-center gap-2'>
            <button
              type='button'
              onClick={() => setQuantidadeConvidadosAdicionais(String(Math.max(0, quantidade - 1)))}
              disabled={quantidade <= 0}
              aria-label='Diminuir quantidade'
              className={classeBotaoQuantidade}
            >
              <AiOutlineMinus aria-hidden='true' />
            </button>
            <input
              id='quantidadeConvidadosAdicionais'
              type='number'
              inputMode='numeric'
              min={0}
              value={quantidadeConvidadosAdicionais}
              onChange={(e) => setQuantidadeConvidadosAdicionais(e.target.value)}
              className='h-12 w-full min-w-0 rounded-xl border border-zinc-300 bg-white px-4 text-center text-lg font-semibold text-zinc-900 focus:border-zinc-900 focus:outline-none focus:ring-2 focus:ring-zinc-900/10'
            />
            <button
              type='button'
              onClick={() => setQuantidadeConvidadosAdicionais(String(quantidade + 1))}
              aria-label='Aumentar quantidade'
              className={classeBotaoQuantidade}
            >
              <AiOutlinePlus aria-hidden='true' />
            </button>
          </div>
        </div>

        {valorUnitario !== undefined && (
          <div className='flex items-baseline justify-between border-t border-zinc-100 pt-4'>
            <span className='text-sm text-zinc-500'>Total</span>
            <span className='text-2xl font-semibold text-zinc-900'>{formatCurrency(quantidade * valorUnitario)}</span>
          </div>
        )}

        <button
          type='button'
          onClick={() => onConfirm()}
          className='flex h-12 w-full items-center justify-center rounded-xl bg-zinc-900 px-5 font-semibold text-white transition-colors hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2'
        >
          Confirmar pedido
        </button>
      </div>
    </ReactModal>
  )
}

export default Modal;
